(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MetaTag', MetaTag);

    MetaTag.$inject = ['$resource', 'ENV'];

    function MetaTag($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/meta-tags/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
